import { useEffect } from "react";
import { Market } from "./api";

/** Match ViewPost metadata for SPA navigation as well as server-rendered direct links. */
export function useMarketMetadata(market?: Market) {
  useEffect(() => {
    if (!market) return;
    const originalTitle = document.title;
    const originalReady = (window as any).renderComplete;
    document.title = `${market.title} | FactWeb 예측시장`;
    const url = `https://factweb.co.kr/markets/${market.id}`;
    const description = market.description
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 160);
    const changes: (() => void)[] = [];
    const set = (
      tag: "meta" | "link",
      key: string,
      value: string,
      content: string,
    ) => {
      let element = document.head.querySelector(`${tag}[${key}='${value}']`);
      const created = !element;
      if (!element) {
        element = document.createElement(tag);
        element.setAttribute(key, value);
        document.head.appendChild(element);
      }
      const attribute = tag === "link" ? "href" : "content";
      const previous = element.getAttribute(attribute);
      const target = element;
      target.setAttribute(attribute, content);
      changes.push(() => {
        if (created) target.remove();
        else if (previous === null) target.removeAttribute(attribute);
        else target.setAttribute(attribute, previous);
      });
    };
    set("meta", "name", "description", description);
    set("meta", "property", "og:title", market.title);
    set("meta", "property", "og:description", description);
    set("meta", "property", "og:url", url);
    set("meta", "property", "og:type", "article");
    set(
      "meta",
      "property",
      "og:image",
      market.thumbnail ? new URL(market.thumbnail, "https://factweb.co.kr").href : "https://factweb.co.kr/images/factweb-share.png",
    );
    set("link", "rel", "canonical", url);
    (window as any).renderComplete = true;
    return () => {
      document.title = originalTitle;
      (window as any).renderComplete = originalReady;
      changes.reverse().forEach((restore) => restore());
    };
  }, [market]);
}
